import { render, staticRenderFns } from "./MiniWizardStickyAmount.vue?vue&type=template&id=d33b3d32"
import script from "./MiniWizardStickyAmount.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickyAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports